module.exports = __webpack_public_path__ + "static/media/cafe2.b8dd3865.jpg";